import React from 'react';
import styles from '../styles/Category.module.css';

const CategoryCard = ({ category, onEdit, onDelete, onToggle }) => (
  <div className={styles.card}>
    <div className={styles.thumbnailWrapper}>
      {category.icon ? (
        <img src={category.icon} alt={category.category} className={styles.thumbnail} />
      ) : (
        <div className={styles.placeholderIcon}>📁</div>
      )}
    </div>
    <div className={styles.cardContent}>
      <h4 className={styles.categoryName}>{category.category}</h4>
      {category.company && (
        <div className={styles.companyName} style={{ fontSize: '0.95em', color: '#888', marginBottom: 4 }}>
          {category.company.name}
        </div>
      )}
      <div className={styles.toggleWrapper}>
        <label className={styles.switch}>
          <input type="checkbox" checked={category.active} onChange={() => onToggle(category.id)} />
          <span className={styles.slider}></span>
        </label>
        <span className={category.active ? styles.active : styles.inactive}>
          {category.active ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className={styles.cardActions}>
        <button className={styles.editBtn} onClick={() => onEdit(category)}>Edit</button>
        <button className={styles.deleteBtn} onClick={() => onDelete(category.id)}>Delete</button>
      </div>
    </div>
  </div>
);

export default CategoryCard;
